import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getCurrentYear } from 'root/lib/DatetimeManager';
import { Row } from './Layouts';

/**
 * Legal, T&S, and privacy at the bottom of the screen.
 */

// Legal links
const T_AND_S = 'http://www.amplify.com/user-terms';
const PRIVACY_POLICY = 'https://www.amplify.com/customer-privacy';
const CREDITS = 'https://my.amplify.com/help/en/articles/5365706-amplify-reading-integrated-ereader#h_a99b723d08';

// Styled components unique to the Footer
const Container = styled(Row)`
  justify-content: space-between;
  position: absolute;
  bottom: 0px;
  left: 0px;
  padding: 10px;
  width: 100%;
  height: 35px;
  background-color: ${({ dark }) => (dark ? 'rgba(0, 0, 0, 0.2)' : 'transparent')};
  font-family: BentonSans;
  font-size: 12px;
  font-weight: 500;
  color: ${({ dark }) => (dark ? '#ffffff' : 'rgba(0, 0, 0, 0.75)')};
  pointer-events:none;
`;

const Legal = styled.div`
  opacity: 0.75;
`;

const Link = styled.a`
  text-decoration: none;
  color: ${({ dark }) => (dark ? '#ffffff' : 'rgba(0, 0, 0, 0.75)')};
  pointer-events: auto;

  &:hover {
    color: ${({ dark }) => (dark ? 'rgba(0, 0, 0, 0.75)' : '#ffffff')};
  }
`;

/**
 * There's a footer at the bottom of all login pages for legal links.
 * It can be light (default) or dark.
 */
const Footer = ({ dark, children }) => (
  <Container dark={dark} data-dd-action-name="legal-links">
    <Legal>&copy; {getCurrentYear()} Amplify Education, Inc</Legal>
    {children}
    <Legal>
      <Link href={T_AND_S} dark={dark} data-dd-action-name="legal-links:terms">
        Terms of Service
      </Link>
      {' '}
      |&nbsp;
      <Link href={PRIVACY_POLICY} dark={dark} data-dd-action-name="legal-links:privacy">
        Privacy Policy
      </Link>
      {' '}
      |&nbsp;
      <Link href={CREDITS} dark={dark} data-dd-action-name="legal-links:credits">
        Credits
      </Link>
    </Legal>
  </Container>
);

// The Footer takes a dark boolean; true enables the darker styling.
// This prop is not required and defaults to false
Footer.propTypes = { dark: PropTypes.bool, children: PropTypes.node };
Footer.defaultProps = { dark: false, children: null };

export default Footer;
